module.exports = __webpack_public_path__ + "img/wx2.c8ce60b5.png";